<template>

</template>
<script setup>
const supabase = useSupabaseClient()
const user = useSupabaseUser()
import {useLocationStore} from '~/stores/useLocationStore'

const locationStore = useLocationStore()

onMounted(async () => {
  if (!user.value) return;
  const {
    data,
    error
  } = await supabase.from('users').select('*,school_admins(id,schools(*))').eq('id', user.value.id).maybeSingle()

  if (data) {
    locationStore.user = data
  }
})


</script>